// **********************************************************
//  Site header
// **********************************************************

/* eslint-disable */

var $affectedElements = $("body, h1, h2, h3, h4, h5, h6, button, a, [class*='text']");

// Change fontsize
function changeFontSize(direction) {
  $affectedElements.each(function () {
    var $this = $(this);
    $this.css('font-size', parseInt($this.css('font-size')) + direction);
  });
}

// Store current fontsize
function store_fontsize() {
  var pathArray = window.location.pathname.split('/');
  var secondLevelLocation = pathArray[1];

  $affectedElements.each(function () {
    var $this = $(this);
    $this.data('orig-size', $this.css('font-size'));
  });
}

// Calc header popup height
function headerPopupHeight() {
  if ($('.header-popup').length) {
    $('body').css('--popupHeight', $('.header-popup').height() + 'px');
  }
}

$(function () {
  $('.accessibility-dropdown__button').on('click', function () {
    $(this).parents('.accessibility-dropdown').toggleClass('is-open');
  });

  $('.hamburger').on('click', function () {
    $('body').toggleClass('is-open-megamenu');
  });

  $('.megamenu__close').on('click', function () {
    $('body').removeClass('is-open-megamenu');
  });

  // Custom selectbox - select2
  $('.custom-select').select2({
    dropdownAutoWidth: true,
    width: '100%',
  });

  // Font increase/decrease
  $('.accessibility-dropdown').on('mouseenter, click', function () {
    store_fontsize();
  });

  var changeSizesInc = 0;
  $('.larger-text-btn').click(function () {
    if (changeSizesInc > 1) return false;
    changeSizesInc++;
    changeSizesDec++;
    changeFontSize(1);
  });

  var changeSizesDec = 0;
  $('.smaller-text-btn').click(function () {
    if (changeSizesDec < -1) return false;
    changeSizesDec--;
    changeSizesInc--;
    changeFontSize(-1);
  });

  // Contrast button
  $('.grayscale-btn').on('click', function (e) {
    $('html').addClass('grayscale-enabled');
  });

  $('.desaturate-btn').on('click', function (e) {
    $('html').removeClass('grayscale-enabled');
  });

  // Feedback form
  $('.feedback-form__trigger').on('click', function () {
    $(this).parent('.feedback-form').toggleClass('is-open');
  });

  // Header popup
  $('.header-popup__close').on('click', function () {
    $(this).parents('.header-popup__bar').addClass('is-hidden');
    headerPopupHeight();
  });

  if ($('.header-popup').length) {
    $('body').addClass('has-header-popup');
  }

  if ($('[data-aos]').length) {
    AOS.init({
      once: true,
      disable: 'mobile',
    });
  }

  setTimeout(function () {
    $('body').addClass('site-loaded');
  }, 4000);
});

$(window).on('load', function () {
  headerPopupHeight();
  $('body').addClass('site-loaded');
});

$(window).resize(function () {
  headerPopupHeight();
});
/* eslint-enable */
